import PropTypes from 'prop-types'
import { memo } from 'react'

import { StyledTextContainer } from './styles'

const Text = ({ widescreenConfig }) => {
  if (!widescreenConfig?.text) {
    return null
  }

  return (
    <StyledTextContainer
      $backgroundColor={widescreenConfig.backgroundTextColor}
      $textAlign={widescreenConfig.textAlign}
      dangerouslySetInnerHTML={{ __html: widescreenConfig.text }}
    />
  )
}

Text.propTypes = {
  widescreenConfig: PropTypes.object,
}

export default memo(Text)
